"use client"

import React, { useState } from "react"
import { Button } from "@/components/ui/button"
import { downloadZumenTemplate } from "@/actions/fastapi"
import { Loader2 } from "lucide-react"

type FileType = "dxf" | "jww"

const ZumenDownload: React.FC = () => {
  const [loadingDXF, setLoadingDXF] = useState<boolean>(false)
  const [loadingJWW, setLoadingJWW] = useState<boolean>(false)
  const [error, setError] = useState<string>("")

  const handleDownload = async (fileType: FileType): Promise<void> => {
    try {
      if (fileType === "dxf") {
        setLoadingDXF(true)
      } else {
        setLoadingJWW(true)
      }
      setError("")

      await downloadZumenTemplate("wrc", fileType)

      // ダウンロード成功時の処理（必要に応じて追加）
    } catch (err) {
      if (err instanceof Error) {
        setError(err.message)
      } else {
        setError("An unexpected error occurred")
      }
    } finally {
      if (fileType === "dxf") {
        setLoadingDXF(false)
      } else {
        setLoadingJWW(false)
      }
    }
  }

  return (
    <div className="space-y-4">
      {error && (
        <div className="text-red-500">エラーが発生しました: {error}</div>
      )}
      <div className="flex flex-col md:flex-row md:space-x-4 space-y-4 md:space-y-0">
        <Button
          onClick={() => handleDownload("dxf")}
          disabled={loadingDXF}
          className="w-full md:w-auto"
        >
          {loadingDXF && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
          DXFファイルをダウンロード
        </Button>
        <Button
          onClick={() => handleDownload("jww")}
          disabled={loadingJWW}
          className="w-full md:w-auto"
        >
          {loadingJWW && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
          JWWファイルをダウンロード
        </Button>
      </div>
      <p className="text-sm text-muted-foreground">
        上のボタンをクリックすると、DXF形式とJWW形式のCADファイルをダウンロードできます。
      </p>
    </div>
  )
}

export default ZumenDownload
